module.exports = __webpack_public_path__ + "img/icon-Cal-Google.13681a4f.png";